// Leaflet a richiesta: ~150 KB di JS piu' 11 KB di CSS che prima venivano
// scaricati, interpretati ed eseguiti su OGNI pagina del sito, mentre la mappa
// sta solo in quattro view (le due pagine sedi, la mappa promo, il footer).
//
// Il CSS viaggia insieme al chunk: se resta importato da app.scss, resta
// bloccante su tutte le pagine e meta' del guadagno sparisce.

let leafletPromise = null;

window.loadLeaflet = function () {
    if (!leafletPromise) {
        leafletPromise = Promise.all([
            import("leaflet"),
            import("leaflet/dist/leaflet.css"),
        ]).then(([module]) => {
            const L = module.default ?? module;
            window.leaflet = L;
            // Il codice delle view usa la globale L: va popolata prima che il
            // loro callback parta.
            window.L = window.L || L;
            return window.L;
        });
    }

    return leafletPromise;
};
